import {
  titleUI,
  descriptionUI,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { adaptiveAutoDescription } from '../../content/additionalBenefits';

export default {
  uiSchema: {
    ...titleUI('Automobile allowance benefits'),
    ...descriptionUI(adaptiveAutoDescription),
    'view:modifyingCar': yesNoUI(
      'Do you need help buying or adapting your car?',
    ),
    'view:alreadyClaimedVehicleAllowance': yesNoUI(
      'Have you ever been granted an automobile allowance?',
    ),
  },
  schema: {
    type: 'object',
    properties: {
      'view:modifyingCar': { type: 'boolean' },
      'view:alreadyClaimedVehicleAllowance': { type: 'boolean' },
    },
  },
};
